export const CHECKOUT_URL = 'https://usaebookpoint.shop/cart/54966666068340:1'

/** Scrolls to the purchase section. Used by every image and CTA on the page. */
export function goToPurchase() {
  const el = document.getElementById('purchase')
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

/** Sends the user to the external checkout. */
export function goToCheckout() {
  window.location.href = CHECKOUT_URL
}
